import React from "react";
import { Row, Col, Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { autoFormatNPWP } from "../../../registrasi/utils/registerUtils.js";

const EditTraderForm = ({ trader, setTrader, propinsi, kota, handlePropinsiChange, onViewDoc, onReplaceDoc, isReplacingDoc }) => {
    return (
        <>
            {/* NPWP */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    NPWP Perusahaan*
                </Form.Label>
                <Col sm="7">
                    <Form.Control
                        type="text"
                        pattern=".{21}"
                        maxLength="21"
                        placeholder="NPWP Perusahaan 16 Digit"
                        required
                        value={trader.NPWP || ""}
                        onChange={(e) => setTrader({ ...trader, NPWP: e.target.value })}
                        onInput={(e) => { e.target.value = autoFormatNPWP(e.target.value); }}
                    />
                </Col>
                <Col sm="2" className="align-self-center">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Lihat NPWP</Tooltip>}>
                        <Button size="sm" variant="info" onClick={() => onViewDoc(trader.FILE_ID, 1)}>
                            <FaEye />
                        </Button>
                    </OverlayTrigger>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Ganti File NPWP
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="file"
                        accept=".pdf,.png,.jpg,.jpeg"
                        disabled={isReplacingDoc}
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) onReplaceDoc(1, file);
                            e.target.value = ""; // reset input, siap dipakai lagi
                        }}
                    />
                    <Form.Text muted>Unggah file baru di sini kalau pemohon mengirim dokumen NPWP perbaikan. Maks. 1MB.</Form.Text>
                </Col>
            </Form.Group>

            {/* Nama Perusahaan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0">
                    Nama Perusahaan*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Nama Perusahaan"
                        value={trader.NAMA || ""}
                        onChange={(e) => setTrader({ ...trader, NAMA: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* NIB */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Nomor Induk Berusaha (NIB)
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Nomor*
                </Form.Label>
                <Col sm="7">
                    <Form.Control
                        type="text"
                        placeholder="Nomor izin usaha"
                        value={trader.NO_IZIN || ""}
                        onChange={(e) => setTrader({ ...trader, NO_IZIN: e.target.value })}
                        required
                    />
                </Col>
                <Col sm="2" className="align-self-center">
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>Lihat NIB</Tooltip>}>
                        <Button size="sm" variant="info" onClick={() => onViewDoc(trader.FILE_ID, 3)}>
                            <FaEye />
                        </Button>
                    </OverlayTrigger>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Ganti File NIB
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="file"
                        accept=".pdf,.png,.jpg,.jpeg"
                        disabled={isReplacingDoc}
                        onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) onReplaceDoc(3, file);
                            e.target.value = "";
                        }}
                    />
                    <Form.Text muted>Unggah file baru di sini kalau pemohon mengirim dokumen NIB perbaikan. Maks. 1MB.</Form.Text>
                </Col>
            </Form.Group>

            {/* Alamat Kantor */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark">
                    Alamat Kantor
                </Form.Label>
            </Form.Group>
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-top mb-0 ps-5">
                    Jalan / No / Rt / Rw
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        rows="4"
                        placeholder="Alamat Kantor"
                        value={trader.ALAMAT || ""}
                        onChange={(e) => setTrader({ ...trader, ALAMAT: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* Propinsi */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Propinsi*
                </Form.Label>
                <Col sm="9">
                    <select
                        className="form-select mb-3 shadow-none"
                        value={trader.PROPINSI || ""}
                        onChange={(e) => {
                            setTrader({ ...trader, PROPINSI: e.target.value });
                            handlePropinsiChange(e);
                        }}
                        required
                    >
                        <option value="">Pilih Propinsi</option>
                        {propinsi.map((item) => (
                            <option key={item.KODE_PROPINSI} value={item.KODE_PROPINSI}>
                                {item.URAIAN_PROPINSI}
                            </option>
                        ))}
                    </select>
                </Col>
            </Form.Group>

            {/* Kota */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Kabupaten / Kota*
                </Form.Label>
                <Col sm="9">
                    <select
                        className="form-select mb-3 shadow-none"
                        value={trader.KOTA || ""}
                        onChange={(e) => setTrader({ ...trader, KOTA: e.target.value })}
                        required
                    >
                        <option value="">Pilih Kabupaten/Kota</option>
                        {kota.map((item) => (
                            <option key={item.KODE_KOTA} value={item.KODE_KOTA}>
                                {item.URAIAN_KOTA}
                            </option>
                        ))}
                    </select>
                </Col>
            </Form.Group>

            {/* Kode Pos */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Kode Pos
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Kode Pos"
                        value={trader.KODEPOS || ""}
                        onChange={(e) => setTrader({ ...trader, KODEPOS: e.target.value })}
                    />
                </Col>
            </Form.Group>

            {/* Telepon Kantor */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 ps-5">
                    Telepon / Faksimili
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="text"
                        placeholder="Telepon Kantor"
                        value={trader.TELEPON || ""}
                        onChange={(e) => setTrader({ ...trader, TELEPON: e.target.value })}
                    />
                </Col>
            </Form.Group>

            {/* Email Kantor */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-self-center mb-0 text-dark ps-5">
                    Pos Elektronik / Email*
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        type="email"
                        placeholder="Email Kantor"
                        value={trader.EMAIL || ""}
                        onChange={(e) => setTrader({ ...trader, EMAIL: e.target.value })}
                        required
                    />
                </Col>
            </Form.Group>

            {/* Keterangan */}
            <Form.Group as={Row} className="form-group">
                <Form.Label column sm="3" className="control-label align-top mb-0 ps-5">
                    Keterangan
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        as="textarea"
                        rows="4"
                        placeholder="Keterangan"
                        value={trader.KETERANGAN || ""}
                        onChange={(e) => setTrader({ ...trader, KETERANGAN: e.target.value })}
                    />
                </Col>
            </Form.Group>
        </>
    );
};

export default EditTraderForm;